<template>
  <b-modal id="policy-detail-modal" size="xxl" centered :title="$t('policy.detail')" hide-footer style="min-width: 1500px;" @hide="onClosed">
    <div><policy-edit-mode @onFormError="onFormError" :product="product" /></div>
    <div class="d-flex mt-4 ml-auto justify-content-end" style="max-width: 24rem; gap: 0.75rem;">
      <button v-if="isEditing" @click="save()" :disabled="isUpdating || hasError || !isSaveButtonEnable" class="button save-button w-50 flex-shrink-1">
        {{ $t("common.save") }}
      </button>
      <button @click="closeModal()" class="button cancel-button w-50 flex-shrink-1">
        {{ $t("common.cancel") }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import PolicyCategoryBadge from "./policy-category-badge";
import PolicyEditMode from "./policy-edit-mode";

import PolicyStatusSelect from "./policy-status-select";

export default {
  props: ["product"],
  components: { PolicyCategoryBadge, PolicyStatusSelect, PolicyEditMode },
  data() {
    return {
      hasError: false,
    };
  },
  computed: {
    isUpdating() {
      return this.$store.getters["organizationPolicy/isUpdating"];
    },
    isDisabled() {
      return this.isLoading;
    },
    isReading() {
      return this.$store.getters["organizationPolicy/isReading"];
    },
    isEditing() {
      return this.$store.getters["organizationPolicy/isEditing"];
    },
    isCreating() {
      return this.$store.getters["organizationPolicy/isCreating"];
    },

    showTaskDetailModal() {
      return this.$store.getters["organizationPolicy/showTaskDetailModal"];
    },
    policyId() {
      return this.$store.getters["organizationPolicy/policyId"];
    },

    isSaveButtonEnable() {
      const form = this.$store.getters["organizationPolicy/form"];

      if (
        !form ||
        !form.name ||
        ((!form.risks || form.risks.length == 0) && (!form.riskDefinitions || form.riskDefinitions.length == 0)) ||
        ((!form.tasks || form.tasks.length == 0) && (!form.taskDefinitions || form.taskDefinitions.length == 0))
      ) {
        return false;
      }
      return true;
    },
  },
  watch: {
    policyId(v) {
      if (!v && !this.isCreating) {
        return this.closeModal();
      }

      this.$store.dispatch("organizationPolicy/fetchDetail", v);
      this.$bvModal.show("policy-detail-modal");
    },
    isCreating(v) {
      if (!v) return;
      this.$bvModal.show("policy-detail-modal");
    },
  },
  methods: {
    async save() {
      const ok = await this.$root.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        const form = this.$store.getters["organizationPolicy/form"];

        await this.$store.dispatch("organizationPolicy/save", form);
        this.$toast.success(this.$t("common.success"));

        this.$store.commit("organizationPolicy/reset");

        this.$emit("onSave");

        this.closeModal();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    edit(id) {
      this.$store.commit("organizationPolicy/isEditing", true);
      this.$store.commit("organizationPolicy/policyId", id);
    },
    closeModal() {
      return this.$bvModal.hide("policy-detail-modal");
    },
    onClosed() {
      this.$emit("onClosed");
      this.$store.commit("organizationPolicy/reset");
    },
    onFormError(err) {
      this.hasError = !!err;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../organization-policy.scss";
</style>
<style>
.modal-xxl {
  max-width: 1250px !important;
}
</style>
